import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Outlet } from 'react-router-dom';
import SocialSubHeader from '../components/Header/SubHeader/SocialSubHeader/SocialSubHeader';
const SocialPage = () => {
    return (_jsxs(_Fragment, { children: [_jsx(SocialSubHeader, {}), _jsx(Outlet, {})] }));
};
export default SocialPage;
